import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-7 mx-auto flex flex-wrap justify-center radius" }
const _hoisted_2 = { class: "border-b-2 border-fuchsia-600 w-3/5" }
const _hoisted_3 = { class: "text-5xl text-center mb-3" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row" }
const _hoisted_6 = { class: "-mb-px mr-2 last:mr-0 flex-auto text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_8 = { class: "-mb-px mr-2 last:mr-0 flex-auto text-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Youtube ")
const _hoisted_10 = { class: "-mb-px mr-2 last:mr-0 flex-auto text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Twitter ")
const _hoisted_12 = { class: "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded" }
const _hoisted_13 = { class: "px-4 py-5 flex-auto" }
const _hoisted_14 = { class: "tab-content tab-space" }
const _hoisted_15 = { class: "twitter-widget" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RulePopup = _resolveComponent("RulePopup")!
  const _component_fa = _resolveComponent("fa")!
  const _component_News = _resolveComponent("News")!
  const _component_Info = _resolveComponent("Info")!
  const _component_VideoContainer = _resolveComponent("VideoContainer")!
  const _component_GetTweet = _resolveComponent("GetTweet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RulePopup),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.state.unitName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass(["text-md px-5 py-3 shadow-lg rounded block select-none cursor-pointer hover:bg-gray-500 hover:text-white", {
              'text-gray-900-600 bg-white': _ctx.state.openTab !== 1,
              'text-white bg-gray-600': _ctx.state.openTab === 1,
            }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTabs(1)))
          }, [
            _createVNode(_component_fa, { icon: "home" }),
            _hoisted_7
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", {
            class: _normalizeClass(["text-md px-5 py-3 shadow-lg rounded block select-none cursor-pointer hover:bg-gray-500 hover:text-white", {
              'text-gray-900-600 bg-white': _ctx.state.openTab !== 2,
              'text-white bg-gray-600': _ctx.state.openTab === 2,
            }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTabs(2)))
          }, [
            _createVNode(_component_fa, { icon: { prefix: 'fab', iconName: 'youtube' } }),
            _hoisted_9
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", {
            class: _normalizeClass(["text-md px-5 py-3 shadow-lg rounded block select-none cursor-pointer hover:bg-gray-500 hover:text-white", {
              'text-gray-900-600 bg-white': _ctx.state.openTab !== 3,
              'text-white bg-gray-600': _ctx.state.openTab === 3,
            }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTabs(3)))
          }, [
            _createVNode(_component_fa, { icon: { prefix: 'fab', iconName: 'twitter' } }),
            _hoisted_11
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass({
                hidden: _ctx.state.openTab !== 1,
                block: _ctx.state.openTab === 1,
              })
            }, [
              _createVNode(_component_News, {
                unit: _ctx.state.unitSlug,
                size: _ctx.state.size
              }, null, 8, ["unit", "size"]),
              _createVNode(_component_Info, {
                unit: _ctx.state.unitSlug,
                size: _ctx.state.size
              }, null, 8, ["unit", "size"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                hidden: _ctx.state.openTab !== 2,
                block: _ctx.state.openTab === 2,
              })
            }, [
              _createVNode(_component_VideoContainer, {
                unit: _ctx.state.unitSlug,
                size: _ctx.state.size
              }, null, 8, ["unit", "size"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                hidden: _ctx.state.openTab !== 3,
                block: _ctx.state.openTab === 3,
              })
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_GetTweet, {
                  unit: _ctx.state.unitSlug
                }, null, 8, ["unit"])
              ])
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}